<template>
  <el-dialog
    title="站内电话"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
    :append-to-body="true"
    custom-class="video_call_modal"
  >
    <div>
      <div class="video_tips" v-if="orderInfo.orderType == 'TIMELY'">
        {{ "即时服务订单问题咨询/订单加价，请联系平台" }}
      </div>
      <template v-if="orderInfo.orderType == 'TIMELY'">
        <div class="contact_person" v-for="item in contactPersonList">
          <div class="contact_person_info">
            <span>{{ item.nickname }}</span> <span>{{ item.mobile }}</span>
          </div>
          <div class="videocall">
            <span class="video-icon" @click="audioCall(item)"
              ><i class="iconfont iconyuyintonghua"></i
              ><span>语音通话</span></span
            >
            <span class="video-icon" @click="videoCall(item)"
              ><i class="iconfont iconshipin2"></i><span>视频通话</span></span
            >
          </div>
        </div>
      </template>

      <div class="contact_person" v-else>
        <div class="contact_person_info">
          <span>{{ masterInfo.name }}</span>
          <span>{{ masterInfo.username }}</span>
        </div>
        <div class="videocall">
          <span class="video-icon" @click="audioCall(masterInfo)"
            ><i class="iconfont iconyuyintonghua"></i
            ><span>语音通话</span></span
          >
          <span class="video-icon" @click="videoCall(masterInfo)"
            ><i class="iconfont iconshipin2"></i><span>视频通话</span></span
          >
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" style="display: none">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAction, postAction } from "@/api/manage";
export default {
  data() {
    return {
      dialogVisible: false,
      orderInfo: {},
      contactPersonList: [],
      sendData: {
        // id: "170",
        // avatar:
        //   "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80",
        // sendUserNickName: "管理员",
      },
      masterInfo: {},
      avatar: require("@/assets/img/user.png"),
      type:'',
      url: {
        contactPerson: "/common/api/platform_user/query_kefu",
        master: "/user/api/worker/detail",
      },
    };
  },
  // 接收注入的数据
  inject: ["videoCall"],
  mounted() {
    this.getkefuList();
  },
  methods: {
    // 获取后台客服
    getkefuList() {
      getAction(this.url.contactPerson, { pageNo: 1, pageSize: 999 }).then(
        (res) => {
          if (res.data.code == 0) {
            this.contactPersonList = res.data.data.records;
            this.contactPersonList.map((i) => {
              i.sendUserNickName = i.nickname;
            });
          }
          console.log(res.data);
        }
      );
    },
    // 加价申请人信息
    getApplicant(item) {
      this.masterInfo = {
        workerName: item.createBy,
        workerPhone: item.createPhone,
        name: item.createBy,
        username: item.createPhone,
        id: item.applicantId,
      };
    },
    // 获取师傅信息
    getMasterInfo(id) {
      postAction(this.url.master + "?workerId=" + id).then((res) => {
        if (res.data.code == 0) {
          this.masterInfo = res.data.data;
        }
        console.log(res.data);
      });
    },
    // 音频通话
    audioCall(data) {
      let sendData = JSON.parse(JSON.stringify(data));
      sendData.sendCallType = "audio";
      this.videoCall(sendData);
    },
    init(item,type) {
      console.log(item)
      this.dialogVisible = true;
      this.type=type||'';
      this.orderInfo = item || {};
      if (item.workerId) this.getMasterInfo(item.workerId);
      if(item.orderType=='applicant') this.getApplicant(item)
      //  this.getMasterInfo(item.workerId||'6848158308730147867')
    },
    close() {
      this.dialogVisible = false;
    },
    // 模态框关闭回调
    handleClose() {
      this.dialogVisible = false;
      sessionStorage.removeItem("orderId");
      console.log("模态框关闭");
    },
  },
};
</script>

<style lang="scss" scoped>
.video_tips {
  color: #ffad16;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 20px;
}
.contact_person {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;

  .contact_person_info {
    display: flex;
    flex-direction: column;
    color: #5e6066;
    font-size: 12px;
    span {
      line-height: 12px;
      &:first-child {
        margin-bottom: 8px;
      }
    }
  }
}
.videocall {
  height: 14px;
}
.video-icon {
  position: relative;
  i {
    margin: 0 5px 0 16px;
    font-size: 12px;
    color: #3455d3;
  }
  color: #2f3133;
  cursor: pointer;
  &:hover {
    color: #3455d3;
  }
  &:last-child {
    margin-left: 16px;
  }
  &:last-child::before {
    content: "";
    position: absolute;
    height: 12px;
    background: #e8eef5;
    left: 0;
    width: 1px;
    top: calc(50% - 6px);
  }
  span {
    font-size: 12px;
  }
}
</style>
<style lang='scss'>
// #orderlist {
//   .el-dialog__wrapper {
.video_call_modal {
  width: 418px !important;
  // margin-top: 5vh !important;
  // &>.el-dialog__header{
  //   display: none;
  // }
  .el-dialog__headerbtn:focus .el-dialog__close,
  .el-dialog__headerbtn:hover .el-dialog__close {
    color: #3455d3;
  }
}
// }
.video_call_modal {
  .el-dialog {
    width: 418px !important;
  }
  .el-dialog__body,
  .el-dialog__footer {
    background: #fff;
    margin: 0;
  }
  .el-dialog__body {
    // padding: 20px 24px !important;
    padding: 20px 24px !important;
  }
  .el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;
    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }
    .el-dialog__headerbtn {
      top: 16px;
    }
  }
}
// }
</style>
